import React, { useMemo } from 'react'
import { Grid } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import TitleWithText from './TitleWithText'

const RetentionTracking = ({ items = {} }) => {
  const { t } = useTranslation()

  const { retainerType, wearTime, otherRetainerType, otherWearTime } = items || {}

  const retainerTypeText = useMemo(() => {
    if (!retainerType) {
      return null
    }

    if (retainerType === 'other' && otherRetainerType) {
      return otherRetainerType
    }

    return t(`dialogs.hiPatientGuidelinesViewer.categories.retentionTracking.retainerTypeOptions.${retainerType}`)
  }, [otherRetainerType, retainerType, t])

  const wearTimeText = useMemo(() => {
    if (!wearTime) {
      return null
    }

    if (wearTime === 'other' && otherWearTime) {
      return otherWearTime
    }

    return t(`dialogs.hiPatientGuidelinesViewer.categories.retentionTracking.wearTimeOptions.${wearTime}`)
  }, [otherWearTime, t, wearTime])

  if (!retainerTypeText && !wearTimeText) {
    return null
  }

  return (
    <Grid container direction="column" spacing={2}>
      {retainerTypeText && (
        <Grid item>
          <TitleWithText
            title={`${t('dialogs.hiPatientGuidelinesViewer.categories.retentionTracking.retainerType')}:`}
            text={retainerTypeText}
          />
        </Grid>
      )}
      {wearTimeText && (
        <Grid item>
          <TitleWithText
            title={`${t('dialogs.hiPatientGuidelinesViewer.categories.retentionTracking.wearTime')}:`}
            text={wearTimeText}
          />
        </Grid>
      )}
    </Grid>
  )
}

export default RetentionTracking
